<template>
  <section class="documents">
    <div class="container">
      <v-app>
        <div class="pa-7">
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="#005a64"
            grow
          >
            <v-tab>
              Manutenção de Kit's
            </v-tab>
            <v-tab>
              Manutenção de Componentes
            </v-tab>

            <v-tab-item>
              <div class="mt-10">
                
                <v-data-table
                  :headers="headers"
                  :items="kits"
                  class="elevation-1"
                  :search="search"
                  :loading="loading"
                  loading-text="Carregando kit's..."
                >


                  <a-skeleton class="mt-10" :loading="loading" active slot="progress" >
                  </a-skeleton>

                  <template v-slot:top>
                    <div class="mt-">
                      <input
                        type="file"
                        accept=".xls, .xlsx"
                        ref="fileToUpload"
                        @change="lerPlanilha($event)" 
                        style="display: none"
                        id="upload"
                      >
                      <v-btn
                        block
                        color="#005a64"
                        class="white--text"
                        @click="$refs.fileToUpload.click()"
                      >
                        <v-icon
                          left
                          dark
                        >
                          mdi-cloud-upload
                        </v-icon>
                        Upload (Planilha de Componentes)
                      </v-btn>
                    </div>
                    <!-- <v-divider class="ma-5"></v-divider> -->
                    <v-text-field
                      v-model="search"
                      label="Filtro"
                      class="mx-4 mt-5"
                      color="#005a64"
                    >
                      <v-icon
                        slot="append"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-text-field>
                  </template>

                  <template v-slot:[`item.URLIMAGEM`]="{ item }">
                    <v-img
                      class="ma-3"
                      aspect-ratio="1"
                      max-height="100"
                      max-width="100"
                      :lazy-src="item.URLIMAGEM"
                      :src="item.URLIMAGEM"
                    ></v-img>
                  </template>

                  <template v-slot:[`item.options`]="{ item }">
                    <div class="ma-5">
                      {{ item.options }}
                      <v-btn
                        @click="openItemsPage(item)"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="blue"
                      >
                        <v-icon dark>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                      <v-btn
                        @click="openDeleteKitConfirmDialog(item)"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </div>
                  </template>

                </v-data-table>
              </div>
            </v-tab-item>

            <v-tab-item>
              <div class="mt-10">
                <v-data-table
                  :headers="headersComp"
                  :items="comps"
                  class="elevation-1"
                  :search="searchComp"
                  :loading="loadingComp"
                  loading-text="Carregando componentes..."
                >

                  <a-skeleton class="mt-10" :loading="loadingComp" active slot="progress" >
                  </a-skeleton>

                  <template v-slot:top>
                    <v-text-field
                      v-model="searchComp"
                      label="Filtro"
                      class="mx-4"
                      color="#005a64"
                    >
                      <v-icon
                        slot="append"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-text-field>
                  </template>


                  <template v-slot:[`item.COMPONENT`]="{ item }">
                    <div class="ma-5">
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header color="#005a64" class="white--text">
                            <b>
                              {{ item.COMPONENT }}
                            </b>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div class="mt-5">
                              <div>Kit's presentes:</div>
                              <ul class="mt-4">
                                <li v-for="(kit, i) in item.AFFECTED_KITS" :key="i">{{ kit }}</li>
                              </ul>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                     
                    </div>
                  </template>
                  
                  <template v-slot:[`item.AFFECTED_KITS`]="{ item }">
                    <ul>
                      <li v-for="(kit, i) in item.AFFECTED_KITS" :key="i">{{ kit }}</li>
                    </ul>
                  </template>

                  <template v-slot:[`item.options`]="{ item }">
                    <div class="ma-5">
                      {{ item.options }}
                      <v-btn
                        @click="openDeleteCompConfirmDialog(item)"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </v-tab-item>
          </v-tabs>
        </div>

        <v-btn
          fab
          dark
          fixed
          right
          bottom
          color="#005a64"
          @click="window.scrollTo(0,0)"
        >
          <v-icon dark>mdi-arrow-up</v-icon>
        </v-btn>

        <!-- Modal de Dialogo -->
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="600"
          v-model="dialogController.active"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="#005a64"
                dark
              >{{ dialogController.header }}</v-toolbar>

              <v-card-text class="mt-8" v-html="dialogController.message">
              </v-card-text>

              <v-card-actions class="justify-space-between">
                <v-btn
                  v-if="dialogController.action"
                  color="#005a64"
                  text
                  @click="dialogController.action"
                >OK</v-btn>
                <v-btn
                  v-if="!dialogController.actionOnClose"
                  text
                  @click="dialog.value = false"
                >Close</v-btn>
                <v-btn
                  v-else
                  text
                  @click="dialogController.actionOnClose"
                >Close</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>

        <!-- Modal de Loading -->
        <v-dialog v-model="loadingModal.active" persistent width="300">
          <v-card color="#005a64" dark>
            <v-card-text style="padding: 27px">
              {{ loadingModal.message }}
              <v-progress-linear
                style="margin-top: 15px"
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-app>
    </div>
  </section>
</template>

<script>
import axios from "axios"
import XLSX from "xlsx";

export default {
  data() {
    return {
      tab: null,
      token: null,
      baseUrl: `https://www.leverosintegra.com.br/Map/Api`,
      kits: [],
      comps: [],
      search: null,
      searchComp: null,
      loading: false,
      loadingComp: false,
      window: window,
      contentFile: null,
      headers: [
        {
          text: '',
          value: 'URLIMAGEM',
          sortable: false,
        },
        {
          text: 'SKU',
          value: 'SKU',
          sortable: false,
        },
        {
          text: 'Descrição',
          value: 'NOME_ITEM',
          sortable: false,
        },
        {
          text: '',
          value: 'options',
          align: 'right',
          sortable: false,
        },
      ],
      headersComp: [
        {
          text: 'Componente',
          value: 'COMPONENT',
          sortable: false,
        },
        {
          text: '',
          value: 'options',
          align: 'right',
          sortable: false,
        },
      ],
      dialogController: {
        active: false,
        header: null,
        message: null,
        action: null,
        actionOnClose: null
      },
      loadingModal: {
        active: false,
        message: null
      },
      componentsToUpload: []
    }
  },

  created() {
    let dados = JSON.parse(localStorage.getItem("login"));
    this.token = dados.token;

    this.loading = true
    axios.get(
      `${this.baseUrl}/solar?token=${this.token}&function=kits&sku=0`
    ).then(res => {
      this.kits = res.data
      this.loading = false
    }).catch(err => {
      if (err && err.response && err.response.status === 401) {
        window.location = '/login';
        return;
      }
      alert(err)
      this.loading = false
    })
    
    this.loadingComp = true
    axios.get(
      `${this.baseUrl}/solar?token=${this.token}&function=components&sku=0`
    ).then(res => {
      this.comps = res.data
      this.loadingComp = false
    }).catch(err => {
      if (err && err.response && err.response.status === 401) {
        window.location = '/login';
        return;
      }
      alert(err)
      this.loadingComp = false
    })
  },

  methods: {
    openItemsPage(kit) {
      this.$router.push(`/panel/ItemsMaintenance?Kit=${JSON.stringify(kit)}`)
    },
    openDeleteKitConfirmDialog(kit) {
      this.dialogController.header = 'Atenção!'
      this.dialogController.message =
        `Ao prosseguir todos os componentes do kit <b>${kit.NOME_ITEM}</b> serão <b>removidos</b> da base!
        <br><br>
        Essa ação irá refletir imediatamente nos kit's
        <br>
        Deseja continuar?`

      this.dialogController.action = () => {
        this.deleteKit(kit)
      }
      this.dialogController.actionOnClose = null
      this.dialogController.active = true
    },
    openDeleteCompConfirmDialog(comp) {
      this.dialogController.header = 'Atenção!'
      this.dialogController.message =
        `Ao prosseguir o componente <b>${comp.COMPONENT}</b> será <b>removido</b> dos seguintes Kit's:
        <br><br>
        <ul>`
      
      comp.AFFECTED_KITS.forEach(k => {
        this.dialogController.message += `<li>${k}</li>`
      })

      this.dialogController.message += 
        `</ul>
        <br><br>
        Essa ação irá refletir imediatamente nos kit's
        <br>
        Deseja continuar?`

      this.dialogController.action = () => {
        this.deleteComponent(comp)
      }
      this.dialogController.actionOnClose = null
      this.dialogController.active = true
    },

    deleteKit(kit) {
      this.dialogController.active = false
      this.loadingModal.message = `Removendo componente da base de dados...`
      this.loadingModal.active = true
      axios.post(
        `${this.baseUrl}/solar?token=${this.token}&function=kit`,
        {
          sku: kit.SKU
        }
      ).then(res => {

        console.log(res)

        // Remove da visualização
        this.kits.splice(this.kits.indexOf(kit), 1)
        this.loadingModal.active = false

        this.dialogController.header = 'Sucesso!'
        this.dialogController.message =
          `Componentes do kit <b>${kit.NOME_ITEM}</b> removidos com sucesso!`

        this.dialogController.action = null
        this.dialogController.actionOnClose = null
        this.dialogController.active = true

      }).catch(err => {
        if (err && err.response && err.response.status === 401) {
          window.location = '/login';
          return;
        }
        this.loadingModal.active = false
        alert(err)
      })
    },

    deleteComponent(comp) {
      this.dialogController.active = false
      this.loadingModal.message = `Removendo componente da base de dados...`
      this.loadingModal.active = true
      axios.post(
        `${this.baseUrl}/solar?token=${this.token}&function=components`,
        {
          componente: comp.COMPONENT
        }
      ).then(res => {

        console.log(res)

        // Remove da visualização
        this.comps.splice(this.comps.indexOf(comp), 1)
        this.loadingModal.active = false

        this.dialogController.header = 'Sucesso!'
        this.dialogController.message =
          `Componente <b>${comp.COMPONENT}</b> removido com sucesso!`

        this.dialogController.action = null
        this.dialogController.actionOnClose = null
        this.dialogController.active = true


      }).catch(err => {
        if (err && err.response && err.response.status === 401) {
          window.location = '/login';
          return;
        }
        this.loadingModal.active = false
        alert(err)
      })
    },

    lerPlanilha(event) {
      this.arquivoUpload = event.target.files ? event.target.files[0] : null;

      // Valida tipo de documento
      if (this.arquivoUpload) {
        let archiveType = this.arquivoUpload.name.split('.')[1];
        if (archiveType !== 'xls' && archiveType !== 'xlsx') {
          this.arquivoUpload = null;
          alert("Tipo de arquivo selecionado inválido!");
        } else {
          let r = new FileReader();
          this.loadingModal.message = `Carregando planilha...`
          this.loadingModal.active = true
          r.readAsBinaryString(this.arquivoUpload);
          r.onload = (e) => {
            this.contentFile = this.processExcel(e.target.result);
          };
          r.onloadend = () => {
            this.loadingModal.active = false
            this.validate();
          }
        }
      }
    },

    validate() {
      // Valida a quantidade de colunas
      if (this.contentFile[0].length !== 20) {
        alert(`Campos da planilha inválidos, é esperado o total de 20 colunas, a planilha possui somente ${this.contentFile[0].length} verifique!`)
        this.cleanSelectedArchive();
        return;
      }
      
      // Valida cabeçalho da planilha
      if (this.contentFile[0][0] !== "COMPONENTES" ||
          this.contentFile[0][1] !== "KITS" ||
          this.contentFile[0][2] !== "ID_COMPONENT" ||
          this.contentFile[0][3] !== "DESCRIPTION" ||
          this.contentFile[0][4] !== "CHECKED_ITEM" ||
          this.contentFile[0][5] !== "SUG" ||
          this.contentFile[0][6] !== "MIN" ||
          this.contentFile[0][7] !== "MAX" ||
          this.contentFile[0][8] !== "INC" ||
          this.contentFile[0][9] !== "IMGITEM" ||
          this.contentFile[0][10] !== "DESCRIPTION_ITEM" ||
          this.contentFile[0][11] !== "SKUS" ||
          this.contentFile[0][12] !== "SKU_PRINCIPAL" ||
          this.contentFile[0][13] !== "POTENCIA" ||
          this.contentFile[0][14] !== "POTENCIA_CV" ||
          this.contentFile[0][15] !== "ESTAGIOS" ||
          this.contentFile[0][16] !== "CATEGORIA" ||
          this.contentFile[0][17] !== "VALIDA_ESTOQUE" ||
          this.contentFile[0][18] !== "PRAZO_ESTOQUE" ||
          this.contentFile[0][19] != "QTDE_ESTOQUE"
        ) {
        alert("Campos da planilha inválidos, verifique!")
        this.cleanSelectedArchive();
        return;
      }

      this.prepareData();
    },

    prepareData() {
      // Prepara dados para serem enviados para a API
      let header = this.contentFile[0];
      let arrayTemp = this.contentFile;
      arrayTemp.shift();

      let components = [];
      let countLinha = 0;
      try {
        for (let a in arrayTemp) {
          countLinha++;
          // Monta o objeto
          let obj = {};
          // Valida se o objeto existe no array, por padrão devolve null
          obj[header[0]] = arrayTemp[a][0] ? arrayTemp[a][0] : null;
          obj[header[1]] = arrayTemp[a][1] ? arrayTemp[a][1] : null;
          obj[header[2]] = arrayTemp[a][2] ? arrayTemp[a][2] : null;
          obj[header[3]] = arrayTemp[a][3] ? arrayTemp[a][3] : null;
          obj[header[4]] = arrayTemp[a][4] ? arrayTemp[a][4] : null;
          obj[header[5]] = arrayTemp[a][5] ? arrayTemp[a][5] : null;
          obj[header[6]] = arrayTemp[a][6] ? arrayTemp[a][6] : null;
          obj[header[7]] = arrayTemp[a][7] ? arrayTemp[a][7] : null;
          obj[header[8]] = arrayTemp[a][8] ? arrayTemp[a][8] : null;
          obj[header[9]] = arrayTemp[a][9] ? arrayTemp[a][9] : null;
          obj[header[10]] = arrayTemp[a][10] ? arrayTemp[a][10] : null;
          obj[header[11]] = arrayTemp[a][11] ? arrayTemp[a][11] : null;
          obj[header[12]] = arrayTemp[a][12] ? arrayTemp[a][12] : null;
          obj[header[13]] = arrayTemp[a][13] ? arrayTemp[a][13] : null;
          obj[header[14]] = arrayTemp[a][14] ? arrayTemp[a][14] : null;
          obj[header[15]] = arrayTemp[a][15] ? arrayTemp[a][15] : null;
          obj[header[16]] = arrayTemp[a][16] ? arrayTemp[a][16] : null;
          obj[header[17]] = arrayTemp[a][17] ? arrayTemp[a][17] : null;
          obj[header[18]] = arrayTemp[a][18] ? arrayTemp[a][18] : null;
          obj[header[19]] = arrayTemp[a][19] ? arrayTemp[a][19] : null;
          components.push(obj);
        }
      } catch {
        alert(`Erro ao converter coluna para JSON! Linha: ${countLinha}`)
        this.cleanSelectedArchive();
        return;
      }

      // Atualiza as váriaveis
      this.componentsToUpload = components;

      this.dialogController.header = `Atenção!`
      this.dialogController.message = 
        `Ao realizar o upload da nova base toda a base anterior de componentes será <b>excluída</b>!
        <br>
        Caso ocorra algum erro durante o processamento da nova base os registros atuais não serão afetados!
        <br><br>
        Quantidade de linhas na planilha: <b>${this.componentsToUpload.length}</b>.
        <br><br>
        Essa ação irá refletir imediatamente nos kit's
        <br>
        Deseja continuar?
        `
      // Ação ao abrir o modal
      this.dialogController.action = () => {
        this.sendComponentsToSave()
      }
      // Ação ao fechar o modal
      this.dialogController.actionOnClose = () => {
        this.cleanSelectedArchive()
        this.dialogController.active = false
      }
      this.dialogController.active = true
    },

    sendComponentsToSave() {
      this.loadingModal.message = `Realizando upload! Aguarde...`
      this.loadingModal.active = true
      axios.post(
        `${this.baseUrl}/solar?token=${this.token}&function=upload`,
        {
          arrayComponentes: this.componentsToUpload
        },
      ).then(res => {
        
        this.dialogController.header = `Sucesso!`
        this.dialogController.message =
          `Tabela de componentes atualizada com sucesso!`
        this.dialogController.action = null
        this.dialogController.actionOnClose = () => {
          window.location.reload()
        }
        this.loadingModal.active = false
        this.dialogController.active = true

        console.log(res)
      }).catch(err => {
        if (err && err.response && err.response.status === 401) {
          window.location = '/login';
          return;
        }
        this.loadingModal.active = false
        alert(`Erro ao realizar o upload da planilha: \n\n` + err)
      })
    },

    processExcel(data) {
      let workbook = XLSX.read(data, {
        type: "binary"
      });

      let res = this.toJson(workbook);
      return res;
    },

    toJson(workbook) {
      let result;
      workbook.SheetNames.forEach(function (sheetName) {
        let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
          raw: false,
        });
        if (roa.length) result = roa;
      });
      return result;
    },

    cleanSelectedArchive() {
      document.getElementById("upload").value = "";
    }

  },

}
</script>

<style lang="scss" scoped>
.documents {
  .container {
    max-width: 90%;
    margin: 0 auto;

    .header {
      display: flex;
      margin: 20px 0;

      button {
        background: var(--standardGreen);
        color: var(--customWhite);
        border-radius: 5px;
        padding: 10px;
        width: 40%;
      }

      input {
        border-bottom: 1px solid var(--customGray-500);
        outline: none;
        margin-left: 20px;
        color: var(--customGray-500);
        width: 100%;
      }
    }

    .loader {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 80px;

      i {
        color: var(--customBlue);
        font-size: 4rem;
      }
    }

    .table {
      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
          tr {
            th {
              background: var(--customGray-70);
              padding: 5px;
            }
          }
        }

        tbody {
          tr {
            td {
              padding: 10px;
              border-bottom: 1px solid var(--customGray-100);
              text-align: center;

              button {
                background: var(--customGray-100);
                color: var(--customGray-800);
                border-radius: 10px;
                padding: 5px;
                outline: none;
              }

              a {
                color: var(--customDarkGreen);
              }
            }
          }
        }
      }
    }
  }
}
</style>